import React from "react";
import { useApiDocsContext } from "../startup/ApiDocsApp";
import Sidebar from "./Sidebar";
import Introduction from "./Introduction";
import EndpointDetail from "./EndpointDetail";

const ApiDocsLayout = () => {
  const { selectedEndpoint, sidebarOpen, setSidebarOpen } = useApiDocsContext();

  return (
    <div className="api-docs-layout">
      <header className="api-docs-mobile-header">
        <button
          className="api-docs-mobile-menu-btn"
          onClick={() => setSidebarOpen(true)}
          aria-label="Open menu"
        >
          <span className="api-docs-hamburger" />
        </button>
        <a href="/developers" className="api-docs-logo">
          <img src="/Opendate-mark-512.png" alt="Opendate" className="api-docs-logo-image" />
          <span className="api-docs-logo-text">Opendate</span>
          <span className="api-docs-logo-badge">API</span>
        </a>
      </header>
      {sidebarOpen && (
        <div
          className="api-docs-sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      <Sidebar />
      <main className="api-docs-content">
        {selectedEndpoint ? <EndpointDetail /> : <Introduction />}
      </main>
    </div>
  );
};

export default ApiDocsLayout;
